import { Box, Icons, Text } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown';
import { TinValidationCaption } from './TinValidationCaption';
import { TinValidationCompletedResult } from './TinValidationCompletedResult';
import { TinValidationRequestDataTable } from './TinValidationRequestDataTable';
import { useGlobalState } from 'store/reducers/reducer';
import { getTinValidationJob } from 'store/sagas/sagas';
export const TinValidationDropdown = ({ jobSid, parentJobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [tinValidationJob, setTinValidationJob] = useState(null);
    useEffect(() => {
        asyncDispatch(getTinValidationJob(jobSid)).then(setTinValidationJob, console.error);
    }, [jobSid]);
    if (!tinValidationJob)
        return (React.createElement(Dropdown, { title: "TIN" },
            React.createElement(Box, null,
                React.createElement(TinValidationCaption, null),
                React.createElement(Icons.Loading, null))));
    const { request, result, status } = tinValidationJob;
    if (result.status === 'PENDING') {
        return (React.createElement(Dropdown, { title: "TIN" },
            React.createElement(Box, null,
                React.createElement(Text, null, "TIN verification is handled by one of our trusted partners. This step is usually quick, but completion time may vary slightly."),
                React.createElement(Box, { display: "flex", marginTop: "spacing.default", style: { gap: '15px' } },
                    React.createElement(Text, null, "Status:"),
                    React.createElement(Text, { style: { fontWeight: '600' } }, "Pending")),
                React.createElement(TinValidationRequestDataTable, { requestData: request }))));
    }
    return (React.createElement(TinValidationCompletedResult, { jobStatus: status, parentJobStatus: parentJobStatus, requestData: request, tinIsMatch: result.status === 'MATCH' }));
};
